export function transformAddress(input) {
  let shortened =
    input.substring(0, 4) + '...' + input.substring(input.length - 4);
  return shortened;
}
